import { ApiEndpoints } from '../../../utils/app-constants';
import { toCondensedDate, toShortDate } from '../../../utils/date-utils';
import {
    DOCUMENT_EXTENSIONS,
    DOCUMENT_REQUEST_LOCATION,
    IDocumentRequest
} from '../../utilities/document-request';
import { API_METHODS } from '../../utilities/type-models';

export class MonthlyInvoiceReportDocument implements IDocumentRequest {

    public filename: string = '';
    public fileExtension: DOCUMENT_EXTENSIONS = 'pdf';
    public openInTab: boolean = false;
    public reportLocation: DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType: API_METHODS = 'GET';

    public url: string = '';

    constructor(startDate: Date, endDate: Date) {

        const startStr = toShortDate(startDate);
        const endStr = toShortDate(endDate);
        this.url = ApiEndpoints.ACCOUNTING_MONTHLY_INVOICE_REPORT.formattify(startStr, endStr);
        this.filename = `Monthly_Invoice_Report_${toCondensedDate(startDate)}_${toCondensedDate(endDate)}`;

    }

}
